/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Cond_State_NoneInputs */



/**
* | output |
* | --- |
* | "not yet invoiced" |
*
* @param {Partner_Billing_Board_Cond_State_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_cond_state_none = /** @type {((inputs?: Partner_Billing_Board_Cond_State_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Cond_State_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("noch nicht fakturiert")
	return /** @type {LocalizedString} */ ("not yet invoiced")
});